import { AGENT_BASE } from '../services/agentService'

/**
 * The socket URL for a scan, built from the page's own query string.
 *
 * The whole search string is forwarded verbatim rather than being rebuilt from
 * named fields. Signed QR auth is planned: when a token lands in the QR, this
 * page must pass it through without understanding it, and the agent decides.
 * Naming the params here is what would break that.
 *
 * The scheme follows the page, so this becomes wss:// the day TLS lands with no
 * change here.
 */
export function agentSocketUrl(search: string, loc: Location = window.location): string {
  const scheme = loc.protocol === 'https:' ? 'wss' : 'ws'
  const query = search.startsWith('?') ? search : search ? `?${search}` : ''
  return `${scheme}://${loc.host}${AGENT_BASE}/ws${query}`
}
